import create from "zustand";

const useAuthStore = create((set: any) => ({
    loggedIn: false,
    setloggedIn: (data: boolean) => set(() => ({ loggedIn: data })),
}));

export { useAuthStore };
